<div class="modal-header">
  <button type="button" class="close" ng-click="$dismiss()">&times;</button>
  <h4 class="modal-title">{{$ctrl.schedule.gleba.descricao}} - {{$ctrl.schedule.atividade.descricao}} {{($ctrl.schedule.cultivar || {}).descricao || ''}} </h4>
</div>
<div class="modal-body modal-edit-cronograma-fungicidas">
  <div class="fungicidas-edit-label" ng-if="!$ctrl.editScheduleData.editing">
    <div class="col-xs-10 ng-scope fungicidas-summary" >
      <span class="label">
        Plantio: {{$ctrl.schedule.data_plantio | date: 'dd/MM/yy'}}
      </span>
      &nbsp;
      <span class="label">
        Emergência: {{$ctrl.schedule.data_emergencia | date: 'dd/MM'}}
      </span>
      &nbsp;
      <span class="label">
        Ciclo: {{$ctrl.schedule.ciclo_dias}} dias
      </span>
      &nbsp;
      <span class="label">
        Dias do ciclo até hoje: {{$ctrl.schedule.dias_do_ciclo_ate_hoje}}
      </span>
      &nbsp;
      <span class="label">
        Área: {{$ctrl.schedule.area}} ha
      </span>
      &nbsp;
      <span class="label" ng-if="!!$ctrl.schedule.data_estimada_colheita">
        Data estimada de colheita: {{$ctrl.schedule.data_estimada_colheita | date: 'dd/MM/yyyy'}}
      </span>
    </div>
    <div class="col-xs-2 text-right ng-scope">
      <button
          type="button"
          class="btn-xs btn-link btn-edit-cronograma"
          uib-tooltip="Editar"
          tooltip-append-to-body="true"
          ng-click="$ctrl.editSchedule()"
        >
          <i class="fa fa-edit"></i>
        </button>
    </div>
  </div>
  <form name="form" class="form-horizontal edit-cronograma-fungicidas" ng-submit="$ctrl.saveChanges()" ng-if="$ctrl.editScheduleData.editing">
    <h3 class="col-xs-12">
      <span class="ng-binding ng-scope">Editar Cronograma</span>
    </h3>
    <div class="vertical-container edit-fungicida">
      <div class="form-group" ng-class="{'has-warning': $ctrl.formWarnings.area.text}">
        <label for="area" class="control-label col-xs-5">Área</label>
        <div class="col-xs-7">
          <div class="input-group">
            <input
              type="number"
              name="area"
              id="area"
              step="any"
              min="0.01"
              required
              ng-model="$ctrl.editScheduleData.area"
              class="form-control"
            >
            <span class="input-group-addon">
              ha
            </span>
          </div>
          <p class="text-warning" ng-show="$ctrl.formWarnings.area.text">
            {{$ctrl.formWarnings.area.text}}
          </p>
        </div>
      </div>
        <div class="form-group" ng-show="!!$ctrl.editScheduleData.editCultivar">
          <label for="cultivar" class="control-label col-xs-5">Cultivar</label>
          <div class="col-xs-7">
            <i class="fa fa-spinner fa-pulse fa-fw" ng-if="$ctrl.editScheduleData.loading"></i>
            <select
              name="cultivar"
              id="cultivar"
              class="form-control"
              ng-options="cultivar.descricao for cultivar in $ctrl.cultivares track by cultivar.item_id"
              ng-model="$ctrl.editScheduleData.cultivar"
              ng-change="$ctrl.changeCultivar()"
              required
              ng-if="!$ctrl.editScheduleData.loading"
            ></select>
          </div>
        </div>
        <div class="form-group" ng-class="{ 'has-error': form.plantio.$invalid && form.plantio.$dirty }">
          <label for="plantio" class="control-label col-xs-5">Plantio</label>
          <div class="col-xs-7">
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                placeholder="Data"
                ng-model="$ctrl.editScheduleData.datepickerTextArea.plantio"
                ng-change="$ctrl.setCronogramaDate('plantio')"
                text-mask="$ctrl.DATE_MASK"
                required
              >
              <input
                class="hidden-datapicker"
                datepicker-options="$ctrl.editScheduleData.datapickerPlantioOptions"
                ng-change="$ctrl.setTextDatapicker('plantio')"
                uib-datepicker-popup="dd/MM/yyyy"
                ng-model="$ctrl.editScheduleData.plantio"
                is-open="$ctrl.editScheduleData.datepickerPlantio.open"
                id="plantio"
                name="plantio"
                popup-placement="bottom-left"
                required
              >
              <span class="input-group-btn">
                <button type="button" class="btn btn-default" ng-click="$ctrl.editScheduleData.datepickerPlantio.open = !$ctrl.datepickerPlantio.open">
                  <i class="glyphicon glyphicon-calendar"></i>
                </button>
              </span>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="ciclo" class="control-label col-xs-5">Ciclo</label>
          <div class="col-xs-7">
            <div class="input-group">
              <input
                type="number"
                name="ciclo"
                id="ciclo"
                ng-model="$ctrl.editScheduleData.ciclo"
                class="form-control"
              >
              <span class="input-group-addon">
                dias
              </span>
            </div>
          </div>
        </div>
        <div class="form-group" ng-class="{ 'has-error': form.emergencia.$invalid && form.emergencia.$dirty }">
          <label for="emergencia" class="control-label col-xs-5">Emergência</label>
          <div class="col-xs-7">
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                placeholder="Data"
                ng-model="$ctrl.editScheduleData.datepickerTextArea.emergencia"
                ng-change="$ctrl.setCronogramaDate('emergencia'); $ctrl.onEmergenciaChange();"
                text-mask="$ctrl.DATE_MASK"
                required
              >
              <input
                class="hidden-datapicker"
                datepicker-options="$ctrl.datepickerOptions"
                ng-change="$ctrl.setTextDatapicker('emergencia'); $ctrl.onEmergenciaChange();"
                uib-datepicker-popup="dd/MM/yyyy"
                ng-model="$ctrl.editScheduleData.emergencia"
                is-open="$ctrl.editScheduleData.datepickerEmergencia.open"
                id="emergencia"
                min-date="$ctrl.editScheduleData.plantio"
                name="emergencia"
                popup-placement="bottom-left"
                required
              >
              <span class="input-group-btn">
                <button type="button" class="btn btn-default" ng-click="$ctrl.editScheduleData.datepickerEmergencia.open = !$ctrl.editScheduleData.datepickerEmergencia.open">
                  <i class="glyphicon glyphicon-calendar"></i>
                </button>
              </span>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="ciclo" class="control-label col-xs-5">Dias do Ciclo Até Hoje</label>
          <div class="col-xs-7">
            <div class="input-group">
              <input
                type="text"
                name="diasCicloAteHoje"
                id="diasCicloAteHoje"
                ng-model="$ctrl.editScheduleData.diasCicloAteHoje"
                class="form-control"
                disabled
              >
            </div>
          </div>
        </div>
        <div class="form-group" ng-class="{ 'has-error': form.colheitaEstimada.$invalid && form.colheitaEstimada.$dirty }">
          <label for="colheitaEstimada" class="control-label col-xs-5">Data estimada de colheita</label>
          <div class="col-xs-7">
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                placeholder="Data"
                ng-model="$ctrl.editScheduleData.datepickerTextArea.colheitaEstimada"
                ng-change="$ctrl.setCronogramaDate('colheitaEstimada')"
                text-mask="$ctrl.DATE_MASK"
                disabled
              >
              <span class="input-group-btn">
                <button type="button" class="btn btn-default" ng-click="$ctrl.editScheduleData.datepickerColheitaEstimada.open = !$ctrl.editScheduleData.datepickerColheitaEstimada.open">
                  <i class="glyphicon glyphicon-calendar"></i>
                </button>
              </span>
            </div>
          </div>
        </div>
        <hr/>
        <div class="text-right">
          <button
            type="button"
            class="btn btn-link"
            ng-click="$ctrl.cancelChanges()"
            ng-disabled="$ctrl.working"
          >
            Cancelar
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            ng-disabled="form.$invalid || $ctrl.working"
          >
            Salvar
          </button>
        </div>
    </div>
  </form>
  <div class="vertical-container vertical-timeline dark-timeline">
    <cronograma-fungicidas-aplicacao
      ng-repeat="aplicacao in $ctrl.schedule.parameters track by aplicacao.id"
      cronograma="$ctrl.schedule"
      aplicacao="aplicacao"
      on-update="$ctrl.reloadAplicacao(aplicacao)"
      on-update-schedule="$ctrl.reloadSchedule()"
      cancel-new-aplicacao="$ctrl.cancelNewAplicacao()"
    ></cronograma-fungicidas-aplicacao>
  </div>
  <div class="text-right">
      <button
        type="button"
        class="btn btn-success btn-sm"
        ng-disabled="$ctrl.hasNewAplicacao()"
        ng-click="$ctrl.addAplicacao()"
      >
        Adicionar aplicação
        <i class="fa fa-plus"></i>
      </button>
  </div>
</div>
